var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNumList(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    width: "64px",
    height: "64px",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      textIndent: 0,
      textAlign: "start",
      lineHeight: "normal",
      textTransform: "none",
      blockProgression: "tb",
      InkscapeFontSpecification: "Sans"
    },
    d: "M29.5 5.01h-22c-.67 0-.65-1 0-1h22c.66 0 .67 1 0 1zm0 10h-22c-.67 0-.65-1 0-1h22c.66 0 .67 1 0 1zm0 10h-22c-.67 0-.65-1 0-1h22c.66 0 .67 1 0 1zM2.5 20C1.124 20 0 21.124 0 22.5c0 .717 1 .605 1 0 0-.84.66-1.5 1.5-1.5s1.5.66 1.5 1.5S3.34 24 2.5 24c-.66 0-.662 1 0 1 .84 0 1.5.66 1.5 1.5S3.34 28 2.5 28 1 27.34 1 26.5c0-.642-1-.675-1 0C0 27.876 1.124 29 2.5 29S5 27.876 5 26.5c0-.82-.386-1.544-1-2 .605-.457 1-1.186 1-2C5 21.124 3.876 20 2.5 20zm0-10C1.125 10 0 11.125 0 12.5c0 .688 1 .65 1 0 0-.834.666-1.5 1.5-1.5s1.5.666 1.5 1.5c0 .424-.17.785-.5 1.17-.33.383-.806.76-1.313 1.187C1.175 15.71 0 16.784 0 18.5c0 .262.238.5.5.5h4c.677 0 .652-1 0-1H1.156c.203-.96.82-1.69 1.657-2.393.493-.416 1.017-.824 1.437-1.313.42-.49.75-1.078.75-1.794C5 11.125 3.875 10 2.5 10zM2.156.138l-2 2c-.474.474.255 1.15.688.72L2 1.7v6.8c0 .73 1 .61 1 0v-8c0-.59-.628-.578-.844-.362z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNumList);
export default __webpack_public_path__ + "static/media/num-list.cf70bcdb4ebf74b1ee2c776e8f6a2ad0.svg";
export { ForwardRef as ReactComponent };